import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import HeaderCatalog from "../../../components/headerCatalog";
import ActiveIcon from "../../../components/activeIcon";

//Actions
import { fetchRates } from "../../../redux/actions/catalogs/rate/fetchRates";
import { deleteRate } from "../../../redux/actions/catalogs/rate/deleteRate";

// Resources
import { scrollToTop } from "../../resources/utils";
import HeaderCatalogSimple from "../../../components/headerCatalogSimple";

export default function RateList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const rateState = useSelector((state) => state.rateReducer);

  useEffect(() => {
    dispatch(fetchRates());
    scrollToTop();
  }, []);

  if (rateState.fetching || rateState.processing) {
    return <Loader active inline />;
  }

  if (rateState.message === "resource deleted successfully") {
    dispatch(fetchRates());
  }

  const handleDeleteRate = (rate_id) => {
    dispatch(deleteRate(rate_id));
  };

  return (
    <>
      {rateState.error ? (
        <Message negative content={t(rateState.error)} />
      ) : (
        ""
      )}
       <HeaderCatalogSimple title={t("rate_title")} message={rateState.message} />
        <Table color="blue" striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell></Table.HeaderCell>
              <Table.HeaderCell>{t("rate_name")}</Table.HeaderCell>
              <Table.HeaderCell>{t("commission_percentage")}</Table.HeaderCell>
              <Table.HeaderCell>{t("comment")}</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {rateState.rates.map((rate) => (
            <Table.Row key={rate.id}>
              <Table.Cell collapsing><ActiveIcon active={rate.active} /></Table.Cell>
              <Table.Cell>{t(rate.name)}</Table.Cell>
              <Table.Cell>{t(rate.commission_percentage)}</Table.Cell>
              <Table.Cell>{t(rate.comment)}</Table.Cell>
              <Table.Cell className="flex justify-end" >
                <Link to={`/rates/${rate.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
              </Table.Cell>
            </Table.Row>
            ))}
          </Table.Body>
        </Table>
    </>
  );
}
